import { render, staticRenderFns } from "./quickly-generate-insurance-video-commitment-modal.vue?vue&type=template&id=37166c25"
import script from "./quickly-generate-insurance-video-commitment-modal.vue?vue&type=script&lang=js"
export * from "./quickly-generate-insurance-video-commitment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports